<template>
  <div>
    <div class="e-card" style="margin-top: 5px">
      <div
        class="e-card-content"
        style="display: grid; grid-template-columns: repeat(5, 1fr); column-gap: 5%"
      >
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="jurisdictionDS"
          placeholder="Jurisdiction"
          v-model="jurisdiction"
        />
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="facilityStatus"
          placeholder="Facility Status"
          :fields="{ value: 'facilityStatusType' }"
          v-model="facilityStatusType"
        />
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="registrationStatus"
          placeholder="RegistrationStatus"
          :fields="{ value: 'registrationStatusType' }"
          v-model="registrationStatusType"
        />
      </div>
      <div
        class="e-card-content"
        style="display: grid; grid-template-columns: repeat(5, 1fr); column-gap: 5%"
      >
        <ejs-dropdownlist
          float-label-type="Always"
          :dataSource="operationalPrices"
          :fields="registrationFields"
          placeholder="Registration"
          v-model="registrationDesc"
          width="300"
        >
        </ejs-dropdownlist>

        <ejs-multiselect
          id="multiselect"
          float-label-type="Always"
          :dataSource="onHoldes"
          placeholder="Hold Certificate"
          mode="CheckBox"
          :fields="fields"
          width="350"
          v-model="onholdString"
          :showSelectAll="showSelectAll"
          selectAllText="Select All"
          unSelectAllText="unSelect All"
        >
        </ejs-multiselect>
        <div style="width: 2%; padding-top: 4%">
          <ejs-button
            type="button"
            cssClass="e-danger"
            v-on:click.native="onOkButtonClick"
            :disabled="isButtonDisabled"
          >
            Search
          </ejs-button>
        </div>
      </div>
    </div>
    <div style="margin-top: 5px">
      <ejs-grid
        ref="grid"
        :dataSource="reportSites"
        :allowSorting="true"
        :allowPaging="true"
        :allowTextWrap="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        :created="created"
        :toolbarClick="toolbarClick"
        :excelQueryCellInfo="excelQueryCellInfo"
        :allowExcelExport="true"
        height="100%"
        width="100%"
      >
        <e-columns>
          <e-column field="ptmaaFlag" headerText="PTMAA" textAlign="Left" width="100" />
          <e-column field="siteID" headerText="Site Number" textAlign="center" width="100" />
          <e-column field="siteName" headerText="Site Name" textAlign="right" width="280" />
          <e-column field="address" headerText="Site Address" textAlign="right" width="240" />
          <e-column field="muniName" headerText="Municipality" textAlign="right" width="200" />
          <e-column
            field="facilityStatusType"
            headerText="Site Status"
            textAlign="Left"
            width="160"
          />
          <e-column
            field="registrationStatusType"
            headerText="Registration Status"
            textAlign="Left"
            width="160"
          />
          <e-column
            field="selectedOnholds"
            headerText="Hold Certificate items Checked"
            textAlign="Left"
            width="220"
          />
          <e-column field="ownerID" headerText="Owner Number" textAlign="Left" width="100" />
          <e-column
            field="legalName"
            headerText="Owner Company Name"
            textAlign="Left"
            width="250"
          />
          <e-column
            field="comAddress"
            headerText="Owner company address"
            textAlign="Left"
            width="250"
          />
          <e-column
            field="ownerContactName"
            headerText="Owner Contact Name"
            textAlign="Left"
            width="150"
          />
          <e-column
            field="phoneNumber"
            headerText="Owner Phone number"
            textAlign="Left"
            width="150"
          />
          <e-column field="emailAddress" headerText="Owner Email" textAlign="Left" width="250" />
          <e-column field="invoiceNumber" headerText="Invoice #" textAlign="Left" width="120" />
          <e-column
            field="invoiceDate"
            headerText="Invoice Date"
            textAlign="Left"
            width="150"
            type="date"
            :format="gridDateFormat"
          />
          <e-column
            field="registrationDesc"
            headerText="Registration Period"
            textAlign="Left"
            width="200"
          />
          <e-column field="amount" headerText="Amount" textAlign="Left" width="100" format="C2" />
          <e-column
            field="invoiceStatusType"
            headerText="Invoice Status"
            textAlign="Left"
            width="200"
          />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  MultiSelect,
  CheckBoxSelection,
} from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';

import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { mapActions, mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { getRegistrationList5 } from '../services/site-info-api';
import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js'
import {
  FETCH_REGISTRATION_STATUS,
  FETCH_FACILITY_STATUS,
  FETCH_ON_HOLD,
  FETCH_REPORT_SITES,
  SET_REPORT_SITES,
} from '../store';

MultiSelect.Inject(CheckBoxSelection);
Vue.use(MultiSelectPlugin);

Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(GridPlugin);

export default {
  name: 'SiteOnHold',
  data() {
    return {
      applicationType: null,
      dateType: 'Invoice date',
      date: null,
      applicationTypesDS: null,
      jurisdictionDS: ['All', 'ASCA', 'Accredited'],
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 15 },
      jurisdiction: null,
      facilityStatusType: null,
      registrationStatusType: null,
      onholdString: null,
      registrationDesc: null,
      fields: { text: 'onHold', value: 'onHold' },
      showSelectAll: true,
      operationalPrices: null,
      registrationFields: { text: 'registrationDesc', value: 'registrationDesc' },
      gridDateFormat : getDataGridDateFormat(),
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
  computed: {
    ...mapGetters({
      registrationStatus: 'getRegistrationStatus',
      onHoldes: 'getOnHoldes',
      facilityStatus: 'getFacilityStatus',
      reportSites: 'getReportSites',
    }),
    isButtonDisabled() {
      return (
        !this.jurisdiction
        && !this.facilityStatusType
        && !this.registrationStatusType
        && (!this.onholdString || (this.onholdString && this.onholdString.length === 0))
        && !this.registrationDesc
      );
    },
  },
  async created() {
    await this.fetchRegistrationStatus();
    await this.fetchFacilityStaus();
    await this.fetchOnHold();
    // eslint-disable-next-line no-return-assign
    await getRegistrationList5().then((res) => (this.operationalPrices = res.data));
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.grid) {
        document
          .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.grid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    ...mapActions({
      fetchRegistrationStatus: FETCH_REGISTRATION_STATUS,
      fetchFacilityStaus: FETCH_FACILITY_STATUS,
      fetchOnHold: FETCH_ON_HOLD,
      fetchReportSites: FETCH_REPORT_SITES,
    }),
    async onOkButtonClick() {
      let { jurisdiction } = this;
      let { facilityStatusType } = this;
      let { registrationStatusType } = this;
      let { onholdString } = this;
      let { registrationDesc } = this;
      if (
        jurisdiction
        || facilityStatusType
        || registrationStatusType
        || onholdString
        || registrationDesc
      ) {
        if (!jurisdiction) {
          jurisdiction = '';
        }
        if (!facilityStatusType) {
          facilityStatusType = '';
        }
        if (!registrationStatusType) {
          registrationStatusType = '';
        }
        if (!onholdString) {
          onholdString = '';
        }
        if (!registrationDesc) {
          registrationDesc = '';
        }

        await this.fetchReportSites({
          jurisdiction,
          facilityStatusType,
          registrationStatusType,
          onholdString,
          registrationDesc,
        });
      } else {
        await this.$store.commit(SET_REPORT_SITES, { _payload: null });
      }
    },
    excelQueryCellInfo(args) {
      switch(args.column.field){
        case 'invoiceDate':
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.grid.excelExport({
            fileName: reportExportFileName('Sites On Hold.xlsx'),
          });
          break;
      }
    },
  },
};
</script>
<style>
.e-input-group:not(.e-success):not(.e-warning):not(.e-error):not(.e-float-icon-left).e-disabled,
.e-input-group.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error).e-disabled
  .e-input-in-wrap,
.e-input-group
  .e-control-wrapper:not(.e-success):not(.e-warning):not(.e-error):not(.e-float-icon-left)
  .e-disabled,
.e-input-group.e-control-wrapper.e-float-icon-left:not(.e-success):not(.e-warning):not(.e-error)
  .e-disabled
  .e-input-in-wrap {
  border-bottom-color: black !important;
}
</style>
